import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Melody} from "../../model/melody";
import {ContentService} from "../../services/content.service";
import {constants} from "../../constants";
import {Subscription} from "rxjs";
import {DeviceService} from "../../services/device.service";
import {SubscriberService} from "../../services/subscriber.service";
import {SubscriptionStatus} from "../../model/subscription-status";
import {MainPageBanner} from "../../model/main-page-banner";


@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.css'],
  host: {
    class: 'app-page'
  }
})
export class MainPageComponent implements OnInit, OnDestroy {
  @ViewChild('selector') selector: ElementRef;
  hitsMelodies: ReadonlyArray<Melody>;
  newMelodies: ReadonlyArray<Melody>;
  popularMelodies: ReadonlyArray<Melody>;
  mainPageBanners: ReadonlyArray<MainPageBanner>;
  mainPageSpecialBanners: ReadonlyArray<MainPageBanner>;
  privet: boolean;
  privetPlus: boolean

  pageSize: number;

  subscription: Subscription;

  constructor(private readonly contentService: ContentService,
              readonly deviceService: DeviceService,
              private readonly subscriberService: SubscriberService) {
    this.hitsMelodies = [];
    this.newMelodies = [];
    this.popularMelodies = [];
    this.mainPageBanners = [];
    this.mainPageSpecialBanners = [];

    this.pageSize = deviceService.mainPageMelodiesSize;

    this.subscription = new Subscription();
    this.privet = false;
    this.privetPlus = false;
  }

  ngOnInit(): void {
    this.subscription.add(
      this.contentService.hitsMelodies.subscribe(value => this.hitsMelodies = value)
    );

    this.subscription.add(
      this.subscriberService.subscriber.subscribe(subscriber => {
        if (subscriber) {
          this.privet = subscriber.privetStatus == SubscriptionStatus.ACTIVE || subscriber.privetStatus == SubscriptionStatus.ACTIVATING;
          this.privetPlus = subscriber.privetPlusStatus == SubscriptionStatus.ACTIVE || subscriber.privetPlusStatus == SubscriptionStatus.ACTIVATING;
        } else {
          this.privet = false;
          this.privetPlus = false;
        }
      })
    )

    this.subscription.add(
      this.contentService.mainPageBanners.subscribe(banners => this.mainPageBanners = banners)
    )

    this.subscription.add(
      this.contentService.mainPageSpecialBanners.subscribe(banners => this.mainPageSpecialBanners = banners)
    )

    this.contentService.getRandomTagMelodies(constants.newMelodiesTagId, this.pageSize)
      .subscribe(melodies => this.newMelodies = melodies);

    this.contentService.getRandomTagMelodies(constants.popularMelodiesTagId, this.pageSize)
      .subscribe(melodies => this.popularMelodies = melodies);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
